









import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class Cookies extends Vue {
  isCookieInfo: boolean = true;
  closeCookieInfo() {
    localStorage.setItem('cookie', '1');
    this.isCookieInfo = false;
  }
  mounted() {
    if (localStorage.getItem('cookie')) {
      this.isCookieInfo = false;
    }
  }
}
